

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import HomePage from './HomePage';

import D1Page from './D1Page';


import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
// import ClozeExercise from './ClozeExercise';
import SupportRequest from './SupportRequest';
import ContactUs from './ContactUs';
import BetaSignupForm from './BetaSignupForm';
import InsideFlashFluency from './InsideFlashFluency/InsideFlashFluency';
import BlogPostPage from './InsideFlashFluency/BlogPostPage';
import BlogRouter from './InsideFlashFluency/BlogRouter';
// import UserSetup from './UserAccountSetup/UserSetup';
import FAQ from './FAQ';
import KoreanSyllableRecorder from './ProfessionalSyllableRecording/professional_syllable_recording';
import Help from './Help';
import { LearningPreferencesProvider } from './LearningPreferencesContext';

function App() {
  return (
    <Router>
      <LearningPreferencesProvider>
        <Routes>
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/" element={<D1Page />} />
          {/* <Route path="/login" element={<LoginScreen />} /> */}
          {/* <Route path="/account_creation" element={<UserSetup />} /> */}
          {/* <Route path="/platform" element={<Platform />} /> */}
          {/* <Route path="/reading_practice" element={<ReadingFlashcard />} /> */}
          {/* <Route path="/listening_practice" element={<ListeningFlashcard />} /> */}
          {/* <Route path="/pronunciation" element={<PronunciationFlashcard />} /> */}
          {/* <Route path="/writing" element={<WritingExercise /> } /> */}
          {/* <Route path="/grammar_lessons" element={<Grammar />} /> */}
          {/* <Route path="/grammar_lessons/:lessonId" element={<GrammarLesson />} /> */}
          {/* <Route path="/pronunciation_lessons/" element={<PronunciationLessons />} /> */}
          {/* <Route path="/vocabulary" element={<Vocabulary />} /> */}
          {/* <Route path="/vocabulary/:vocabWord" element={<VocabLesson />} /> */}
          {/* <Route path="/statistics" element={<Statistics />} /> */}
          {/* <Route path="/settings" element={<UserSettings />} /> */}
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
          <Route path="/terms_of_service" element={<TermsOfService />} />
          {/* <Route path="/cloze" element={<ClozeExercise />} /> */}
          {/* <Route path="/beta_application" element={< BetaSignupForm/>} /> */}
          <Route path="/support-request" element={<SupportRequest />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/inside-flash-fluency" element={<InsideFlashFluency />} />
          <Route path="/inside-flash-fluency/:slug" element={<BlogPostPage />} />
          <Route path="/inside-flash-fluency/*" element={<BlogRouter />} />
          <Route path="/faq/" element={<FAQ />} />
          <Route path="/professional_syllable_recorder/" element={<KoreanSyllableRecorder />} />
          {/* <Route path="/hangul_curriculum/" element={<HangulCurriculum />} /> */}
          {/* <Route path="/curriculum" element={<AllCurriculums />} /> */}
          {/* <Route path="/personalization" element={<Personalization />} /> */}
          <Route path="/help" element={<Help />} />
          {/* <Route path="/korean_curriculum" element={<KoreanCurriculum />} /> */}
          {/* <Route path="/subscription" element={<Subscription />} /> */}
          <Route path="/beta-signup" element={<BetaSignupForm />} />
        </Routes>
      </LearningPreferencesProvider>
    </Router>
  );
}

export default App;